// extracted by mini-css-extract-plugin
module.exports = {"badgesListContainer":"_2ypit_kRAVSfZm8J5kZ-1b","badgesListTitle":"-gUhK_Bzz0ZdLM9pULN89","badgesContainer":"_2E0pcFIaKMHkNAelOwljAu","badgeToggle":"_2G4lK9EvVLlYlIZaJxNi6v"};